<template>
	<div>
		<app-app-header v-model="indexStore.isHeaderVisible"
						:title="group.name"
						:breadcrumbs="[{text: $t('label.events'), to: $web('events.index')}]"
						:color="group.color ?? $config.public.colors.primary" hide-on-scroll/>

		<app-content>
			<app-header-toolbar :on-top="!indexStore.isHeaderVisible" :color="group.color ?? $config.public.colors.primary">
				<form-input name="search"
							v-model="filterData.search"
							:icon="icons.search"
							type="search"
							enterkeyhint="search"
							hide-details
							inverted
							clearable
							class="flex-grow-x-1"
							@focus="handleSearchInputFocus"
							@blur="handleSearchInputBlur"
							:placeholder="$t('placeholder.search_event')"/>

			</app-header-toolbar>

			<page-content background xs-full sm-full>
				<container xs-full sm-full class="mt-8 md:mt-0">
					<card xs-tile sm-tile>
						<data-loader :url="$api('event_groups.events.index', group.id)"
									 :filter="filterData"
									 :params="params"
									 as-guest
									 :persist-filter-keys="['search']"
									 @filtering="handleApplyingFilter" on-scroll>

							<template #loading>
								<div v-for="modelLoaderItem in 5" class="divided" :key="'model-loader-' + modelLoaderItem">
									<profile-preview-skeleton no-spacing flat event class="lg:px-24"/>
								</div>
							</template>

							<template v-slot="{data}">
								<div v-for="event in data" :key="event.id" class="divided">
									<profile-preview :model="event" :to="$web('events.show.index', event._key)" flat no-spacing class="lg:px-24"/>
								</div>
							</template>

							<template #missing>
								<lazy-missing-info :icon="icons.event"
												   xs-tile sm-tile class="min-h-200" no-spacing
												   :button-icon="icons.search"
												   :button="$t('action.find_event')"
												   :to="$web('events.index')"
												   :text="$t('missing.event_group.events')">
								</lazy-missing-info>
							</template>

							<template #missingsearch>
								<lazy-missing-info :icon="icons.event"
												   xs-tile sm-tile class="min-h-200" no-spacing
												   :button-icon="icons.search"
												   :button="$t('label.all_events')"
												   :to="$web('events.index')"
												   :text="$t('missing.search')">
								</lazy-missing-info>
							</template>
						</data-loader>
					</card>
				</container>
			</page-content>

		</app-content>
	</div>
</template>

<script setup lang="ts">
import {mdiCalendarMultiple} from '@mdi/js';
import {searchIcon} from "@spoferan/nuxt-spoferan/icons";
import {useIndexStore} from "../../../store";

const indexStore = useIndexStore();
const {t} = useI18n();
const route = useRoute();
const {value: cacheBusterValue} = useCacheBuster('group_ts');

const {data: group} = await useApiFetch(`/v1/view/event-groups/${route.params.group}`, {
	guest: true,
	params: {
		ts: cacheBusterValue,
	}
});

if (group && group._key !== route.params.group) {
	await navigateTo({params: {group: group._key}}, {
		redirectCode: 308
	});
}

const filterData = ref({
	search: route.query.search,
});

const {
	handleApplyingFilter,
	handleSearchInputFocus,
	handleSearchInputBlur
} = useSearchPage();

const params = {
	relations: ['sportTypes', 'labels'],
	ts: cacheBusterValue
}

const icons = {
	event: mdiCalendarMultiple,
	search: searchIcon,
};

useMeta({
	title: t('view.event_groups.show.title', {event_group: group.name}),
	description: t('view.event_groups.show.description', {event_group: group.name}),
})

</script>

